import { useEffect } from "react";
import "./Navbar.css";

function Navbar() {
  useEffect(() => {
    const links = document.querySelectorAll(".menu a");
    const checkbox = document.getElementById("menu-btn");

    links.forEach((link) => {
      link.addEventListener("click", () => {
        if (checkbox) checkbox.checked = false;
      });
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", () => {
          if (checkbox) checkbox.checked = false;
        });
      });
    };
  }, []);

  return (
    <>
      <nav className="nav" role="navigation" aria-label="Main navigation">
        <a href="/" className="logo" aria-label="Homepage link">
          <img
            src="../Assets/navLogo.svg"
            alt="Positanonboard Logo"
            width="100"
            height="auto"
          />
        </a>

        <input
          className="menu-btn"
          id="menu-btn"
          type="checkbox"
          aria-label="Toggle menu"
          role="button"
        />
        <label htmlFor="menu-btn" className="menu-icon" aria-hidden="true">
          <span className="nav-icon"></span>
        </label>

        <ul className="menu">
          <li><a href="#Home">Home</a></li>
          <li><a href="#Photo">Photo Gallery</a></li>
          <li><a href="#Tours">Tours</a></li>
          <li><a href="#Booking">Book Tours</a></li>
          <li><a href="#Reviews">Customer Reviews</a></li>
          <li><a href="#Contacts">Contacts</a></li>
        </ul>
      </nav>
    </>
  );
}

export default Navbar;
